import { matchSorter } from 'match-sorter';

// Types
import type { SpGroupType } from '@/utils/hooks/swr/group/useSPGroups';
// Utils
import useSPGroups from '@/utils/hooks/swr/group/useSPGroups';
import useTranslation from '@/utils/hooks/translation/useTranslation';

import { sortGroups } from '@/utils/sort/profiles/sortGroups';
import { useProfilesStore } from '@/utils/zustand/providers/profiles-provider';

// Components
import { SearchBox } from '@/components/composite/SearchBox/SearchBox';
import { SearchGroupsItems } from '@/components/layouts/LayoutPlatform/components/Header/components/ManageProfiles/Popover/GroupsTab/SearchGroupsItems';
import { SearchInput } from '@/components/layouts/LayoutPlatform/components/Header/components/ManageProfiles/Popover/SearchInput';
import { SearchListWrapper } from '@/components/layouts/LayoutPlatform/components/Header/components/ManageProfiles/Popover/SearchListWrapper';

export type GroupsFormattedType = SpGroupType & {
    selected: boolean;
};

export function GroupsTab() {
    const { t } = useTranslation('layout_platform');
    const { activatedSpGroups } = useSPGroups({ revalidateIfStale: false });
    const { manageGroups, activeGroupId } = useProfilesStore((state) => state);

    const getInitialData = () => {
        const formattedGroups = activatedSpGroups.map((group) => ({
            ...group,
            disabled: true,
            social_profiles: group.social_profiles.filter((profile) => profile.active),
            selected: group.id === activeGroupId
        }));

        return matchSorter(formattedGroups, '', {
            baseSort: (a, b) => sortGroups('sort_asc', a.item, b.item)
        });
    };

    return (
        <SearchBox
            searchKeys={{
                threshold: matchSorter.rankings.CONTAINS,
                keys: ['name']
            }}
            isMultiSelect={false}
            inputId="groups"
            initialData={getInitialData()}>
            <SearchBox.Wrapper<GroupsFormattedType>
                withoutStyle
                data-testid="search-box-wrapper-groups"
                className="flex h-80 flex-col"
                onSelectionChange={(groups) => manageGroups(groups[0])}>
                <SearchInput placeholder={t('manage_profiles.tab_groups.search_placeholder')} />
                <SearchListWrapper
                    type="groups"
                    no_data_message={t(
                        'layout_platform:manage_profiles.tab_groups.search_no_result'
                    )}>
                    <SearchGroupsItems />
                </SearchListWrapper>
            </SearchBox.Wrapper>
        </SearchBox>
    );
}
